import { Section, Store } from '@/types/store';
import { Page } from '@/types/pageSchema';
import { create } from 'zustand';

interface DefaultStoreState {
    // Store identification
    store: Store | null;
    storeId: number | null;
    storeType: string | null;
    storeName: string | null;

    // Store configuration
    theme: string;
    primaryColor: string | null;
    secondaryColor: string | null;
    primaryFont: string | null;

    // Store content
    sections: Section[];
    allPages: Page[];
    pages: Page[]; // Non-landing pages
    landingPages: Page[];
    publishedPages: Page[];
    pagesWithSections: Array<Section | Page>;

    // Actions
    setDefaultStore: (
        store: Store,
        storeId: number,
        storeType: string,
        storeName: string,
        storeData: {
            theme: string;
            primaryColor: string | null;
            secondaryColor: string | null;
            primaryFont: string | null;
            sections: Section[];
            allPages: Page[];
            pages: Page[];
            landingPages: Page[];
            publishedPages: Page[];
            pagesWithSections: Array<Section | Page>;
        }
    ) => void;
    clearDefaultStore: () => void;
}

export const useDefaultStore = create<DefaultStoreState>()(set => ({
    // Initial state
    store: null,
    storeId: null,
    storeType: null,
    storeName: null,
    theme: 'default',
    primaryColor: null,
    secondaryColor: null,
    primaryFont: null,
    sections: [],
    allPages: [],
    pages: [],
    landingPages: [],
    publishedPages: [],
    pagesWithSections: [],

    // Actions
    setDefaultStore: (store, storeId, storeType, storeName, storeData) => {
        set({
            store,
            storeId,
            storeType,
            storeName,
            ...storeData,
        });
    },

    clearDefaultStore: () => {
        set({
            store: null,
            storeId: null,
            storeType: null,
            storeName: null,
            theme: 'default',
            primaryColor: null,
            secondaryColor: null,
            primaryFont: null,
            sections: [],
            allPages: [],
            pages: [],
            landingPages: [],
            publishedPages: [],
            pagesWithSections: [],
        });
    },
}));
